var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdvertiserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3337 7.16684V10.5002M8.54199 5.0835H5.66699C4.26686 5.0835 3.56679 5.0835 3.03201 5.35599C2.56161 5.59567 2.17916 5.97812 1.93947 6.44853C1.66699 6.98331 1.66699 7.68337 1.66699 9.08351L1.66699 10.0835C1.66699 10.8601 1.66699 11.2484 1.79386 11.5546C1.96302 11.963 2.28747 12.2875 2.69585 12.4566C3.00214 12.5835 3.39042 12.5835 4.16699 12.5835V16.1252C4.16699 16.3186 4.16699 16.4154 4.17502 16.4969C4.25296 17.2882 4.879 17.9142 5.6703 17.9921C5.75178 18.0002 5.84852 18.0002 6.04199 18.0002C6.23547 18.0002 6.33221 18.0002 6.41369 17.9921C7.20498 17.9142 7.83103 17.2882 7.90897 16.4969C7.91699 16.4154 7.91699 16.3186 7.91699 16.1252V12.5835H8.54199C10.014 12.5835 11.8147 13.3726 13.2039 14.1299C14.0143 14.5717 14.4196 14.7926 14.685 14.7601C14.9311 14.7299 15.1172 14.6194 15.2614 14.4178C15.417 14.2003 15.417 13.7652 15.417 12.8949V4.77207C15.417 3.90183 15.417 3.46671 15.2614 3.24924C15.1172 3.04759 14.9311 2.93709 14.685 2.90694C14.4196 2.87444 14.0143 3.09534 13.2039 3.53713C11.8147 4.29443 10.014 5.0835 8.54199 5.0835Z",
    stroke: "#084F4B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvertiserIcon);
export default __webpack_public_path__ + "static/media/advertiser-icon.029d26a1bde457d1afa4034322033cfd.svg";
export { ForwardRef as ReactComponent };